<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-2 col-md-4 mb-3" v-for="(label, key) in report.buckets" :key="key">
        <div class="card">
          <div class="card-body p-3">
            <p class="text-xs mb-1 text-uppercase font-weight-bold">{{ label }}</p>
            <h6 :class="'font-weight-bolder mb-0 '+(['d61_90','d90'].includes(key) ? 'text-danger' : (key == 'd1_30' || key == 'd31_60' ? 'text-warning' : ''))">{{ fmt(report.totals[key]) }}</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-warning text-white text-sm" v-if="report.missingRates && report.missingRates.length > 0">
      Kurs <b>{{ report.missingRates.join(', ') }}</b> belum diisi, hutang dalam mata uang ini dihitung 0.
    </div>

    <div class="card">
      <div class="row">
        <div class="col-lg-6">
          <div class="card-header pb-0">
            <h6>Umur Hutang Vendor (AP Aging) &mdash; Total {{ fmt(report.totals.total) }}</h6>
            <p class="text-xs mb-0">Hutang yang sudah diakui & belum dibayar, dalam IDR. Jatuh tempo dari faktur vendor, atau termin PO kalau belum ada faktur.</p>
          </div>
        </div>
        <div class="col-lg-3">
          <label class="form-control-label mt-2 mb-0 text-xs">Per Tanggal</label>
          <input type="date" class="form-control" v-model="asOf" @change="get()">
        </div>
        <div class="col-lg-3">
          <div class="form-check mt-4">
            <input class="form-check-input" type="checkbox" id="detailMode" v-model="detailMode">
            <label class="form-check-label text-sm" for="detailMode">Tampilkan per PO</label>
          </div>
        </div>
      </div>

      <div class="card-body px-0 pt-0 pb-2 mt-3">
        <div class="table-responsive p-0 scroll">
          <table class="table table-striped align-items-center mb-0" v-if="!detailMode">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Vendor</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder" v-for="(label, key) in report.buckets" :key="'h'+key">{{ label }}</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in report.byVendor" :key="i">
                <td class="text-xs font-weight-bold">{{ row.company_name }}</td>
                <td class="text-end text-xs" v-for="(label, key) in report.buckets" :key="'b'+key">{{ row[key] ? fmt(row[key]) : '-' }}</td>
                <td class="text-end text-xs font-weight-bolder">{{ fmt(row.total) }}</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped align-items-center mb-0" v-else>
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder">PO</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Vendor</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Jatuh Tempo</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Telat (hari)</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Outstanding</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">IDR</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Kelompok</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in report.detail" :key="'d'+i">
                <td class="text-xs"><span class="badge badge-sm bg-gradient-primary">{{ row.po_no }}</span></td>
                <td class="text-xs">{{ row.company_name }}</td>
                <td class="text-center text-xs">{{ row.due_date ? moment(row.due_date).locale('id').format('ll') : '-' }}</td>
                <td :class="'text-center text-xs '+(row.days_overdue > 0 ? 'text-danger font-weight-bold' : '')">{{ row.days_overdue !== null ? row.days_overdue : '-' }}</td>
                <td class="text-end text-xs">{{ row.currency }} {{ Number(row.outstanding).toLocaleString('id-ID') }}</td>
                <td class="text-end text-xs font-weight-bold">{{ fmt(row.amount_idr) }}</td>
                <td class="text-center text-xs">{{ report.buckets[row.bucket] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccApAging",
  data() {
    return {
      moment: moment,
      asOf: moment().format('YYYY-MM-DD'),
      detailMode: false,
      report: { buckets: {}, totals: {}, byVendor: [], detail: [], missingRates: [] },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value) {
      return 'IDR '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    get() {
      let context = this;
      Api(context, accounting.apAging({ as_of: context.asOf })).onSuccess(function(response) {
          context.report = response.data.data;
      }).onError(function() {
          toast.error('Data Retrieved Failed', { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      })
      .call()
    },
  }
};
</script>

<style scoped>
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
